<div class="wnl-header">
  <p>
    WNL: Independent with ADL, no assistive devices, strong gait, not scored as fall risk on fall
    scale. Moves all extremities. Full range of motion.
  </p>
  <mat-checkbox [checked]="wnlManager.allWNL" [indeterminate]="wnlManager.someWNL()"
    (change)="wnlManager.setAllWNL($event.checked)">
    All Within Normal Limits
  </mat-checkbox>
</div>

<div [formGroup]="formGroup()" class="form-container">
  <assessment-row title="Mobility/Transfers">
    <emr-input type="select" [hasWNL]="true" [control]="formGroup().controls.mobilityAndTransfers"
      [options]="mobilityAndTransfersOptions" [default]="mobilityAndTransfersDefault"
      [(wnl)]="wnlManager.controlColl['mobilityAndTransfers'].wnl" (wnlChange)="wnlManager.updateAllWNL()" />
  </assessment-row>

  <assessment-row title="Assistive Devices">
    <emr-checkbox-group [hasWNL]="true" [control]="formGroup().controls.assistiveDevices" [options]="deviceOptions"
      [default]="assistiveDevicesDefault" wnlLabel="None" [(wnl)]="this.wnlManager.controlColl['assistiveDevices'].wnl"
      (wnlChange)="wnlManager.updateAllWNL()" />
  </assessment-row>

  <h2>Fall Risk</h2>
  <div class="fall-risk">
    <assessment-row title="Age" subtitle="(single-select)">
      <emr-input type="select" width="60%" [control]="formGroup().controls.fallRiskAge" [options]="ageOptions" />
    </assessment-row>

    <assessment-row title="Fall History" subtitle="(single-select)">
      <emr-checkbox [control]="formGroup().controls.fallHistory" [label]="fallHistoryOption" />
    </assessment-row>

    <assessment-row title="Elimination, Bowel and Urine" subtitle="(single-select)">
      <emr-input type="select" width="60%" [control]="formGroup().controls.fallRiskEbu" [options]="ebuOptions" />
    </assessment-row>

    <assessment-row title="Medications" subtitle="(single-select)" description="Includes PCA/opiates, anticonvulsants,
      anti-hypertensives, diuretics, hypnotics, laxatives, sedatives, and psychotropics">
      <emr-input type="select" width="60%" [control]="formGroup().controls.fallRiskMedications"
        [options]="medicationsOptions" />
    </assessment-row>

    <assessment-row title="Patient Care Equipment" subtitle="(single-select)" description="Any equipment that
      tethers patient (e.g. IV infusion, chest tube, indwelling catheter, SCDs, etc.)">
      <emr-input type="select" width="60%" [control]="formGroup().controls.fallRiskPce" [options]="pceOptions" />
    </assessment-row>

    <assessment-row title="Mobility" subtitle="(multi-select; choose all that apply)">
      <emr-checkbox-group [control]="formGroup().controls.fallRiskMobility" [options]="mobilityFallRiskOptions" />
    </assessment-row>

    <assessment-row title="Cognition" subtitle="(multi-select; choose all that apply)">
      <emr-checkbox-group [control]="formGroup().controls.fallRiskCognition" [options]="cognitionOptions" />
    </assessment-row>

    <assessment-row title="Total Fall Risk Score" description="Sum of all points per category">
      <h3 class="fr-score">{{ computeFallRiskScore() }}</h3>
    </assessment-row>

    <assessment-row title="Fall Risk">
      <h3 class="fr-label">{{ computeFallRiskCategory() }}</h3>
    </assessment-row>

    <assessment-row title="Limited Range of Motion">
      <emr-input type="text" [control]="formGroup().controls.limitedRangeOfMotion" />
    </assessment-row>

    <assessment-row title="Deformaties Present">
      <emr-input type="text" [control]="formGroup().controls.deformitiesPresent" />
    </assessment-row>
  </div>
</div>